import { Map as MaplibreMap } from 'maplibre-gl';
import { FeMapPlugin } from '@fe/maplibre-extensions';
import { DeckOverlayPlugin } from '../deck-overlay/deck-overlay-plugin';
import { FlightsUpdater } from '../flights/flights-updater';
import { ParkedUpdater } from '../parked/parked-updater';
import { RoutesLayer } from '../routes/routes-layer';
import { ScheduledUpdater } from '../scheduled/scheduled-updater';
import { Selection } from '../selection';

export class FlightLayerFacade implements FeMapPlugin {
    public readonly routes: RoutesLayer = new RoutesLayer();
    public readonly parked: ParkedUpdater = new ParkedUpdater();
    public readonly scheduled: ScheduledUpdater;
    public readonly selection: Selection = new Selection();
    public readonly flights: FlightsUpdater;
    public readonly deckPlugin: DeckOverlayPlugin;
    public readonly workspaceId: number;

    constructor(workspaceId: number) {
        this.workspaceId = workspaceId;
        this.scheduled = new ScheduledUpdater(this.workspaceId);
        this.flights = new FlightsUpdater(this.selection, this.workspaceId);
        this.deckPlugin = new DeckOverlayPlugin(this.workspaceId, this.flights, this.selection, this.parked, this.scheduled);
    }

    onAdd(map: MaplibreMap) {
        this.deckPlugin.onAdd(map);
        this.routes.onAdd(map);
    }

    onRemove() {
        this.routes.onRemove();
        this.deckPlugin.onRemove();
    }
}
